<template>
  <div>
    {{ this.text }}
  </div>
</template>

<script>
export default {
  name: "SearchQueryTotals",
  data() {
    return {};
  },
  props: {
    results: Object,
    info: String
  },
  computed: {
    startRange() {
      return this.results?.results.length === 0
        ? 0
        : this.results.fromValue + 1;
    },
    endRange() {
      if (this.results?.results.length === 0) {
        return 0;
      } else if (this.results.length < this.results.sizeValue) {
        return this.results.totals;
      } else {
        return this.startRange + this.results.results.length - 1;
      }
    },
    totalResults() {
      const totals = this.results.totals;
      // Elasticsearch 7 result format || Elasticsearch 6 result format
      let value = totals.value;
      if (value == undefined) {
        value = totals;
      }
      return this.formatNumber(value);
    },
    text() {
      let text = "";
      if (this.results?.results && this.info === "global") {
        text =
          `Showing ${this.startRange}-${this.endRange}` +
          ` of ${this.totalResults} results.`;
      } else if (this.results?.results && this.info === "detailed") {
        text =
          `Found ${this.totalResults} results.  ` +
          `Showing results ${this.startRange}-${this.endRange}.` +
          `  Page ${this.results.currentPage} of ` +
          `${this.results.totalPages}.`;
      } else if (this.results?.results) {
        text =
          `Search results ${this.startRange}-${this.endRange}` +
          ` of ${this.totalResults}`;
      } else {
        text = "No results found.";
      }
      return text;
    }
  },
  methods: {
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
  }
};
</script>

<style lang="scss" scoped>
.results-totals {
  border-top: 1px solid $black;
  border-bottom: 1px solid $black;
  padding: 1em 0;
  text-align: left;
}
</style>
